import { RentalStatistic } from '../rental-statistic';

export class RentalStatisticWrapper {
  userId: number;
  statistic: RentalStatistic;
}

